import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import log from '../logger';
const OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID || '';
const OKTA_URL = process.env.REACT_APP_OKTA_URL || '';
const AUTHORIZATION_URL = process.env.REACT_APP_AUTHORIZATION_URL || '';
export const OKTA_CALLBACK = '/callback';
if (!OKTA_CLIENT_ID)
    log.warn('OKTA_CLIENT_ID is empty');
if (!OKTA_URL)
    log.warn('OKTA_URL is empty');
if (!AUTHORIZATION_URL)
    log.warn('AUTHORIZATION_URL is empty');
const getRedirectURI = () => {
    return window.location.origin + '/callback';
};
const base = {
    appName: 'Pulse',
    appFullName: 'Pulse',
    oAuth: {
        clientId: OKTA_CLIENT_ID,
        scopes: [
            'profile',
            'openid',
            'email',
            'legacy_username',
            'product_line:pulse::read:',
            'product_line:pmp_cps_mmx::read:',
            'product_line:platform.referencedata.global::read:',
            'product_line:pulse_plan::read:'
        ],
        grantType: 'authorization_code',
        pkce: true,
        cookies: { secure: true, httpOnly: true },
        responseMode: 'fragment',
        disableHttpsCheck: true,
        redirectUri: getRedirectURI(),
        issuer: OKTA_URL,
        authorization: AUTHORIZATION_URL,
        storage: 'memory'
    }
};
const oktaAuth = new OktaAuth(base.oAuth);
const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    const safeUri = toRelativeUrl(originalUri || '/', window.location.origin);
    if (safeUri.startsWith('http://') ||
        safeUri.startsWith('https://') ||
        safeUri.startsWith('//')) {
        log.warn('Blocked redirect to absolute URL', { originalUri, safeUri });
        window.location.replace('/');
        return;
    }
    window.location.replace(safeUri);
};
export { oktaAuth, restoreOriginalUri };
